'use client';

import { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';

interface IntlProviderProps {
  children: ReactNode;
  locale: string;
  messages: Record<string, string>;
}

const handleIntlError = (error: { code: string; message: string }) => {
  if (error?.code === 'MISSING_TRANSLATION') {
    console.warn(`Missing translation: ${error?.message}`);
  } else {
    console.warn(error);
  }
};

export function IntlProviderWrapper({ children, locale, messages }: IntlProviderProps) {
  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale="en" onError={handleIntlError}>
      {children}
    </IntlProvider>
  );
}
